import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppLoader from "../../../components/AppLoader";
import DashboardStatus from "../../../components/Dashboard/DashboardStatus";
import StatusCard from "../../../components/Dashboard/StatusCard";
import NavigationDrawer from "../../../components/NavigationDrawer";
import appcolors from "../../../constants/Colors";
import { getWorkerUpcommingJobs } from "../../../services/worker/appointmentApiFn";
import { getWorkerDashboardStates } from "../../../services/worker/authenticationApiFn";
import { handleOpenSnackBar } from "../../../utils";
import WorkerTodaysJobs from "./workerTodaysJobs";
import WorkerUpcommingJobs from "./WorkerUpcommingJobs";
import { t } from "i18next";

function WorkerDashboard() {
  const [isLoading, setIsLoading] = useState({
    states: false,
    jobs: false,
  });
  const [allJobs, setAllJobs] = useState([]);
  const [todaysJobs, setTodaysJobs] = useState([]);
  const [dashboardStates, setDashboardStates] = useState(null);
  const userData = useSelector((state) => state.userData.user);

  useEffect(() => {
    if (userData) {
      fetchDashboardStates();
      fetchAllUpcommingJobs();
    }
  }, [userData]);

  const fetchDashboardStates = async () => {
    try {
      setIsLoading((l) => ({ ...l, states: true }));
      const response = await getWorkerDashboardStates(userData?._id);
      if (response.data.status === "success") {
        const data = response.data.data;
        setDashboardStates(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading((l) => ({ ...l, states: false }));
    }
  };

  const fetchAllUpcommingJobs = async () => {
    try {
      setIsLoading((l) => ({ ...l, states: true }));
      const response = await getWorkerUpcommingJobs(userData?._id);
      if (response.data.status === "success") {
        const data = response.data.data;
        setAllJobs(data.upcomingJobs);
        setTodaysJobs(data.todaysJobs);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading((l) => ({ ...l, states: false }));
    }
  };

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  const sDate = new Date(currentYear, currentMonth - 1, 1); // Start of the month
  const eDate = new Date(currentYear, currentMonth, 0, 23, 59, 59, 999);

  const cardData = [
    {
      primary: "totalJobs",
      secondary: "allJobCounts",
      value: dashboardStates?.totalAppointments || 0,
    },
    {
      primary: "completeJobs",
      secondary: "allCompletedJobCounts",
      value: dashboardStates?.completedAppointments || 0,
    },
    {
      primary: "totalServices",
      secondary: "yourTotalServices",
      value: dashboardStates?.totalSubServices || 0,
    },
  ];

  return (
    <NavigationDrawer>
      <AppLoader isVisible={isLoading.states} />
      <Typography
        variant="h3"
        fontSize={"1.125rem"}
        fontWeight={600}
        color={appcolors.gunmetal}
      >
        {t("welcomeMrkDesk")}
      </Typography>
      <DashboardStatus userImage={userData?.profileImg} />

      <Grid container mt={2} spacing={2} mb={3}>
        {cardData?.map((val, _ind) => {
          return <StatusCard item={val} index={_ind} />;
        })}
      </Grid>

      <Grid container mt={3} spacing={2}>
        <Grid item xs={12} md={6}>
          <WorkerUpcommingJobs allJobs={allJobs} isLoading={isLoading} />
        </Grid>
        <Grid item xs={12} md={6}>
          <WorkerTodaysJobs allJobs={todaysJobs} isLoading={isLoading} />
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default WorkerDashboard;
